import React, { Component, Suspense, useEffect, useState } from 'react';
import { scheduleIdleWork } from '../../utils/scheduleIdleWork';

function loadMessagingWidgetWithRetry(attempt = 0) {
  return import('./MessagingWidget').catch((err) => {
    const isChunk = err?.name === 'ChunkLoadError'
      || /Loading chunk|ChunkLoadError/i.test(String(err?.message || err || ''));
    if (isChunk && attempt < 2) {
      return new Promise((resolve, reject) => {
        window.setTimeout(() => {
          loadMessagingWidgetWithRetry(attempt + 1).then(resolve, reject);
        }, 800 * (attempt + 1));
      });
    }
    throw err;
  });
}

const MessagingWidget = React.lazy(() => loadMessagingWidgetWithRetry(0));

/**
 * Si le chunk messagerie échoue (réseau lent / timeout),
 * on masque le chat sans faire planter Cartographie / le reste de l’app.
 */
class MessagingLoadBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.warn('[DeferredMessagingWidget] soft-fail', error?.message || error);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

/**
 * Charge le widget messagerie hors du chemin critique (INP Desktop).
 * Le bouton chat n'apparaît qu'après idle — le métier reste identique.
 */
export default function DeferredMessagingWidget() {
  const [ready, setReady] = useState(false);

  useEffect(() => scheduleIdleWork(() => setReady(true), 1800), []);

  if (!ready) return null;
  return (
    <MessagingLoadBoundary>
      <Suspense fallback={null}>
        <MessagingWidget />
      </Suspense>
    </MessagingLoadBoundary>
  );
}
